// Drill-down for one plan row: the order lines rolled up into the SKU.
// Kept OUT of the main table per PJ (2026-06-26: "we do not need to show
// customers in the fill plan") — exposed only on row click (06-29 addendum).

import type { FillPlanSku } from './types';
import styles from './FillPlan.module.css';

const fmt = (n: number) => Math.round(n).toLocaleString('en-US');

export function ContributingOrdersPanel({
  sku,
  onClose,
}: {
  sku: FillPlanSku;
  onClose: () => void;
}) {
  return (
    <aside className={styles.drawer} aria-label="Contributing orders">
      <div className={styles.drawerHd}>
        <button type="button" className={styles.drawerClose} onClick={onClose}>
          ×
        </button>
        <div className={styles.prod}>{sku.name}</div>
        <div className={styles.code}>
          {sku.code} · {sku.department} · {sku.orders.length} contributing order
          line{sku.orders.length === 1 ? '' : 's'}
        </div>
      </div>
      <div className={styles.drawerBody}>
        <div className={styles.drawerSection}>Contributing orders</div>
        {sku.orders.map((o) => (
          <div key={o.order + o.units} className={styles.orderLine}>
            <div className={styles.orderName}>{o.order || '—'}</div>
            <div className={styles.orderMeta}>
              <b>{fmt(o.units)}</b> units
              {o.dayUnits
                .map((u, d) => ({ u, d }))
                .filter(({ u, d }) => d >= 1 && u > 0)
                .map(({ u, d }) => ` · D${d}: ${fmt(u)}`)
                .join('')}
            </div>
            <div className={styles.orderMeta}>
              req: {o.requiredBy ?? '—'} · {o.mtoStatus ?? '—'}
              {o.criticalPo && ' · critical PO'}
              {o.score !== null && ` · score ${o.score.toLocaleString('en-US')}`}
            </div>
          </div>
        ))}
        <div className={styles.drawerSection}>Product</div>
        <div className={styles.kv}>
          <span>On hand (Madison)</span>
          <span>{fmt(sku.fgInvMadison)}</span>
        </div>
        <div className={styles.kv}>
          <span>On hand (Solon)</span>
          <span>{fmt(sku.fgInvSolon)}</span>
        </div>
        <div className={styles.kv}>
          <span>On hand (total)</span>
          <span>{fmt(sku.fgInv)}</span>
        </div>
        {sku.poLandingDate && (
          <div className={styles.kv}>
            <span>Critical PO lands</span>
            <span>{sku.poLandingDate}</span>
          </div>
        )}
        {sku.fillPeriod !== null && (
          <div className={styles.kv}>
            <span>Day-1 run order</span>
            <span>{sku.fillPeriod}</span>
          </div>
        )}
      </div>
    </aside>
  );
}
